export default __webpack_public_path__ + "static/media/404.cd03fb67.png";